import { applyMiddleware, compose, createStore } from "redux";
import { keepAliveMiddleware } from "../middleware/keepAliveMiddleware";
import { saveDraftMiddleware } from "../middleware/saveDraftMiddleware";
import { rootReducer } from "../reducers";
import { AppStore } from "../types/AppStore";

/** Hook to redux dev tools. */
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const setStoreForTestsOnly = (store: AppStore) => {
  appStore = store;
};

export const getStore = () => {
  if (!appStore && window.location === window.parent.location) {
    appStore = createStore(
      rootReducer,
      composeEnhancers(
        applyMiddleware(saveDraftMiddleware, keepAliveMiddleware)
      )
    );
  }
  return appStore;
};

let appStore: AppStore;
